import {useClerk} from '@clerk/clerk-react'
import {Button} from './ui/button'
import {Card, CardContent, CardHeader, CardTitle} from './ui/card'

/**
 * Shown when an authenticated Clerk user cannot enter the app — a settled
 * denial, not a transient failure. Default copy covers the 401 case (account
 * not linked to any organization); callers pass title/message for other
 * settled denials (e.g. the archived-organization 403, which renders the
 * server's own message). Without this, the root layout would spin and then
 * fall through to a generic "check your connection" error, leaving the user
 * stuck with no explanation and no way out.
 */
export function NoAccessScreen({
	title = 'No access to this workspace',
	message = "Your account isn't linked to an organization yet. Ask your administrator to send you an invitation, then sign in again.",
}: {
	title?: string
	message?: string
}) {
	const {signOut} = useClerk()

	return (
		<div className='flex justify-center items-center h-dvh bg-background p-4'>
			<Card className='w-full max-w-md'>
				<CardHeader>
					<CardTitle>{title}</CardTitle>
				</CardHeader>
				<CardContent className='space-y-4'>
					<p className='text-muted-foreground'>{message}</p>
					<Button
						variant='outline'
						onClick={() => signOut({redirectUrl: '/sign-in'})}
					>
						Sign out
					</Button>
				</CardContent>
			</Card>
		</div>
	)
}
